import type { PractitionerTypeFragment } from "@shared/data/fragments/PractitionerTypeFragment/PractitionerTypeFragment.fragment";
import { usePractitionerTypesQuery } from "@shared/data/queries/PractitionerTypesQuery/PractitionerTypes.query";
import { useSearchParams } from "@shared/react-router-dom/react-router-dom";

export const useDesignations = (designations?: PractitionerTypeFragment[]) => {
  const [searchParams] = useSearchParams();
  const { data, loading } = usePractitionerTypesQuery({
    skip: !!designations, // use designations from props instead of query when provided
  });
  const practitionerTypes: PractitionerTypeFragment[] =
    data?.practitionerTypes || designations || [];

  const isMDExperiment = searchParams.get("version") === "mdnd";

  const getTypes = (): PractitionerTypeFragment[] => {
    if (loading) {
      return [];
    }
    if (!isMDExperiment) {
      return practitionerTypes;
    }

    // filter logic
    const filteredPractitionerTypes = practitionerTypes.filter(type => {
      return (
        type.description === "Licensed Medical Doctor" ||
        type.description === "Licensed Naturopathic Doctor" ||
        type.description === "Other Licensed Healthcare Provider"
      );
    });

    return filteredPractitionerTypes;
  };

  return {
    designations: getTypes(),
    loading,
  };
};
